import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip as RadixTooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from '@cargomatic/ui';
import { getClassName } from '../../utils/ui/classes';
import InfoIcon from './icons/InfoIcon';

const CargomaticTooltip = forwardRef(
  ({ children, position, className, body, bodyParams, dataTestId }, _ref) => (
    <TooltipProvider>
      <RadixTooltip>
        <TooltipTrigger asChild>
          <div data-testid={dataTestId} className={getClassName(className)}>
            {body(bodyParams)}
          </div>
        </TooltipTrigger>
        <TooltipContent side={position}>{children}</TooltipContent>
      </RadixTooltip>
    </TooltipProvider>
  ),
);

const positions = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};

function renderIcon(params) {
  const { size } = params;
  return <InfoIcon size={size} />;
}

CargomaticTooltip.displayName = 'CargomaticTooltip';

CargomaticTooltip.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string,
  position: PropTypes.oneOf(Object.keys(positions)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  body: PropTypes.func,
  bodyParams: PropTypes.object,
};

CargomaticTooltip.defaultProps = {
  position: positions.right,
  className: '',
  body: renderIcon,
  bodyParams: { size: 'small' },
};

export default CargomaticTooltip;
